import { z } from "zod";

import { DateIsoString } from "@/core/types";
import { CurrencyCodelist } from "@/data/codelists";
import { RelatedEntities } from "@/data/related";

import { TimeReportClient } from "./TimeReportClient";
import { TimeReportHiringManager } from "./TimeReportHiringManager";
import { TimeReportProject } from "./TimeReportProject";
import { TimeReportProjectSummary } from "./TimeReportProjectSummary";
import { TimeReportStageCodelist } from "./TimeReportStage";
import { TimeReportWorker } from "./TimeReportWorker";

export const TimeReportGuid = z.string();
export type TimeReportGuid = z.infer<typeof TimeReportGuid>;

export const TimeReportSystemId = z.string();
export type TimeReportSystemId = z.infer<typeof TimeReportSystemId>;

export const TimeReport = z
  .object({
    guid: TimeReportGuid,
    systemId: TimeReportSystemId,
    lastReadDate: DateIsoString,

    creationDate: DateIsoString,
    modificationDate: DateIsoString,
    startDate: DateIsoString,
    endDate: DateIsoString,
    submitDate: DateIsoString.nullable(),
    stage: TimeReportStageCodelist,
    currency: CurrencyCodelist,
    remainingSpendPercentage: z.number().nullable(),

    projects: z.array(TimeReportProject),
    summary: z.array(TimeReportProjectSummary),

    client: TimeReportClient,
    worker: TimeReportWorker,
    hiringManager: TimeReportHiringManager,

    version: z.number(),
    versionCount: z.number(),
    relatedEntities: RelatedEntities,
  })
  .passthrough();

export type TimeReport = z.infer<typeof TimeReport>;
